import { render, staticRenderFns } from "./IconElectric.vue?vue&type=template&id=dbba0ca0"
import script from "./IconElectric.vue?vue&type=script&lang=js"
export * from "./IconElectric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports